module.exports = {
	//
	spacingXSmall: '0.5rem',
	//
	spacingXxxSmall: '0.125rem',
	//
	spacingXxSmall: '0.25rem',
	//
	borderWidthThin: '1px',
	//
	borderStrokeWidthThin: '1px',
	//
	spacingSmall: '0.75rem',
	//
	componentSpacingMargin: '0',
	//
	borderStrokeWidthThick: '2px',
	//
	borderWidthThick: '2px',
	//
	spacingMedium: '1rem',
	//
	componentSpacingPadding: '1rem',
	//
	spacingNone: '0',
	//
	spacingXLarge: '4rem',
	//
	spacingXxLarge: '8rem',
	//
	spacingLarge: '2rem',
	// 1024px, for tablet devices and larger.
	mqLarge: 'only screen and (min-width: 64em)',
	//
	timing5: '.8s',
	// Active link color
	colorBlueMidnightBlue: 'rgb(0, 57, 107)',
	//
	borderRadiusLarge: '.5rem',
	//
	lineHeightReset: '1',
	//
	fontSizeMedium: '1rem',
	// Hover and focus link color
	colorBlueEndeavour: 'rgb(0, 95, 178)',
	//
	colorBlueSparta: 'rgb(230, 236, 242)',
	//
	colorBlueZodiac: 'rgb(23, 50, 77)',
	// Salesforce Sans Regular
	fontWeightRegular: '400',
	//
	fontSizeXLarge: '1.25rem',
	//
	colorBlueGhost: 'rgb(125, 152, 179)',
	//
	colorOrangeAlert: 'rgb(255, 183, 93)',
	//
	timingTest: '5s',
	//
	colorGreenSea100: 'rgb(53, 212, 204)',
	//
	colorBlueRollingstone: 'rgb(64, 96, 127)',
	//
	borderRadiusCircle: '50%',
	//
	colorBlueSky100: 'rgb(108, 183, 250)',
	//
	fontSizeXxLarge: '1.5rem',
	//
	fontSizeXMedium: '0.875rem',
	//
	colorGreenSea300: 'rgb(46, 194, 186)',
	//
	colorBlueRhino: 'rgb(41, 71, 102)',
	//
	colorBlueBigstoneBlue: 'rgb(10, 31, 51)',
	//
	colorGreenSuccess: 'rgb(75, 202, 129)',
	//
	colorBlueSky300: 'rgb(68, 162, 245)',
	// 448px, for phone devices and larger.
	mqSmall: 'only screen and (min-width: 28em)',
	//
	colorWhite: 'rgb(255, 255, 255)',
	//
	borderRadiusSmall: '.125rem',
	// font-face should be 'Salesforce Sans'.
	fontFamilyBody:
		"'Salesforce Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
	//
	colorPurpleRain100: 'rgb(173, 144, 245)',
	//
	fontSizeLarge: '1.125rem',
	//
	colorGreenSea500: 'rgb(39, 171, 164)',
	//
	colorBlueSky500: 'rgb(45, 147, 237)',
	//
	colorBlueSpider: 'rgb(163, 184, 204)',
	//
	borderRadiusMedium: '.25rem',
	//
	colorPurpleRain300: 'rgb(146, 113, 232)',
	//
	colorGreenSea700: 'rgb(32, 150, 145)',
	//
	colorBlueSky700: 'rgb(32, 129, 214)',
	//
	colorBlueAluminium: 'rgb(92, 122, 153)',
	// 768px, for phone devices and larger.
	mqMedium: 'only screen and (min-width: 48em)',
	//
	colorPurpleRain500: 'rgb(122, 86, 214)',
	//
	colorGreenSea900: 'rgb(27, 130, 125)',
	//
	colorBlueSky900: 'rgb(25, 112, 189)',
	//
	fontSizeXSmall: '0.625rem',
	//
	borderRadiusPill: '5rem',
	//
	colorPurpleRain700: 'rgb(100, 63, 192)',
	//
	colorPurpleRain900: 'rgb(89, 65, 149)',
	//
	lineHeightHeading: '1.25',
	// Disabled link color
	colorBlueBiscay: 'rgb(22, 50, 92)',
	// 1280px, for desktop screens and larger.
	mqXLarge: 'only screen and (min-width: 80em)',
	//
	fontSizeSmall: '0.75rem',
	//
	lineHeightText: '1.5',
	// Link color (508)
	colorBlueScience: 'rgb(0, 112, 210)',
	//
	timing1: '.1s',
	// Salesforce Sans Bold
	fontWeightBold: '700',
	//
	timing2: '.2s',
	//
	timing3: '.4s',
	//
	colorRedError: 'rgb(212, 80, 76)',
	//
	colorBlueAthens: 'rgb(242, 246, 250)',
	//
	colorBlueRome: 'rgb(197, 211, 224)',
	//
	timing4: '.6s',
	// Salesforce Sans Light
	fontWeightLight: '300',
};
